import { render, staticRenderFns } from "./TfacIndividualTableStudentFileInfo.vue?vue&type=template&id=e658a348"
import script from "./TfacIndividualTableStudentFileInfo.vue?vue&type=script&lang=js"
export * from "./TfacIndividualTableStudentFileInfo.vue?vue&type=script&lang=js"
import style0 from "./TfacIndividualTableStudentFileInfo.vue?vue&type=style&index=0&id=e658a348&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports